export default __webpack_public_path__ + "static/media/page10.7c31341e.webp";